export default "__VITE_ASSET__98b62ea9__$_?nuxt_component=async__"